import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate as t } from "../../../infrastructure/translate/localization";

import "./pagination.scss";

const Pagination = ({ pages, current, perPage, next, prev }) => {
  return (
    <div className="pagination left" hidden={pages <= 1}>
      {perPage > 0 && (
        <p className="pagination-showed">
          {t("common-messages.per-page", { perPage })}
        </p>
      )}

      <p className="pagination-text">
        {t("common-messages.pag")} <span>{current + 1}</span>{" "}
        {t("common-messages.of")} <span>{pages}</span>
      </p>

      <div className="page-buttons">
        <button
          type="button"
          disabled={current === 0}
          className="page-item"
          onClick={prev}
        >
          <FontAwesomeIcon icon="angle-left" />
          <span>{t("actions.prev")}</span>
        </button>
        <button
          type="button"
          disabled={current === pages - 1}
          className="page-item"
          onClick={next}
        >
          <span>{t("actions.next")}</span>
          <FontAwesomeIcon icon="angle-right" />
        </button>
      </div>
    </div>
  );
};

Pagination.defaultProps = { perPage: undefined };

Pagination.propTypes = {
  pages: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
  perPage: PropTypes.number,
};

export default Pagination;
